module.exports = __webpack_public_path__ + "img/syukyaku-sytem-005.d184cfed.jpg";